import { DataGrid, GridSelection } from '@tableau/data-grid-3-wrapper';
import * as React from 'react';
import { SortableHeader } from '../../common/react/components/dataGrid/SortableHeader';
import { ListResult } from '../../ts/fetchers/ListResult';
import { IGranteePermissions } from '../../ts/models/IGranteePermissions';
import { ExplorerStyles } from '../spaces/Explorer/ExplorerStyles';
import { DataGridCells } from '../spaces/ListView/DataGridCells';
import { SectionGroup } from './SectionGroups';

export type PermissionsGridProps = {
  /** Permissions to display as rows of this grid */
  permissions: ListResult<IGranteePermissions>;

  /** The section groups (aka templates) to display as columns */
  templates: ReadonlyArray<SectionGroup>;
};

export type PermissionsGridState = {
};

export class PermissionsGrid extends React.Component<PermissionsGridProps, PermissionsGridState> {
  public state: PermissionsGridState = {
  };

  private rows: DataGrid.Row[] = [];
  private cols: DataGrid.Column[] = [];

  private handleCellClick = (): void => {
    // TODO: STORY 891711
  }

  private getRowStore = (): DataGrid.RowStore => {
    return {
      getItems: (start: number, end: null, rowHandler: (rows: DataGrid.Row[]) => void) => {
        // TODO: STORY 891713
        rowHandler(this.rows);
      }
    } as DataGrid.RowStore;
  }

  private selectionHandler = (): GridSelection => {
    return {
      isSelected: (cell: DataGrid.Cell): boolean => {
        // TODO: STORY 891713
        return false;
      }
    };
  }

  private generateContent = (): void => {
    // TODO: STORY 891713
    this.cols = this.props.templates.map((column): DataGrid.Column => {
      return {
        name: column.name,
        dataKey: column.locKey,
        headerText: column.name,
        resizable: false,
        sortable: false,
        headerFormatter: SortableHeader.Formatter(),
        cellFormatter: DataGridCells.CheckboxCell({
          onCheckboxClicked: () => {},
          isRowSelected: (rowKey: DataGrid.Row) => { return false; },
          checkboxCellTestIdFn: (row: DataGrid.Row) => { return column.name; },
        }),
      };
    });

    if (this.props.permissions) {
      this.rows = this.props.permissions.items.map((value: IGranteePermissions, index: number) => {
        return {
          key: index.toString(),
          data: value,
        };
      });
    } else {
      this.rows = new Array(0);
    }
  }

  public render(): JSX.Element {
    this.generateContent();
    return (
      <div className="tb-permissions-grid-react">
        <DataGrid
          cols={ this.cols }
          rowStore={ this.getRowStore() }
          showVerticalGridLines={ true }
          showHorizontalGridLines={ true }
          showRowBanding={ false }
          onCellClick={ this.handleCellClick }
          selectionModel={ this.selectionHandler() }
          style={{ overflow: 'unset', }}
        />
      </div>
    );
  }
}
